import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import starIcon from "Assets/newicons/notify/star/glyph/star-glyph-16-px-yellow.svg";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import { ErrorMessages } from "../../../../../../Constants";

class preview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      threecodes: [],
      fourcodes: [],
      fivecodes: [],
      participents: [],
      participanttypeid: null,
      selectedParticipant: null,
    };
    this.isBackButtonClicked = false;
    this.onSubmit = this.onSubmit.bind(this);
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  async componentDidMount() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', this.onBeforeUpload);
    this.props.onRef({
      onNext: this.onSubmit,
      nextButtonLabel: "Save",
    });
    const { selectedData } = this.props;
    const ParticipantType = await instance.get(`perform/reviewstructureparticipant/${selectedData && selectedData.reviewstructureid}`);
    let participents = ParticipantType.data.result || [];
    const data1 = await instance.get(`perform/getratingscale`);
    const threepoint = data1.data.result.find((rate) => rate.ratingscaletypeid == 1);
    const threecodes = [];
    const fourcodes = [];
    const fivecodes = [];
    threepoint && Object.keys(threepoint).forEach((key) => {
      if (key == "oneunicode" || key == "twounicode" || key == "threeunicode") {
        threecodes.push(threepoint[key]);
      }
    });
    const fourpoint = data1.data.result.find((rate) => rate.ratingscaletypeid == 2);
    fourpoint && Object.keys(fourpoint).forEach((key) => {
      if (key == "oneunicode" || key == "twounicode" || key == "threeunicode" || key == "fourunicode") {
        fourcodes.push(fourpoint[key]);
      }
    });
    const fivepoint = data1.data.result.find((rate) => rate.ratingscaletypeid == 3);
    fivepoint && Object.keys(fivepoint).forEach((key) => {
      if (key == "oneunicode" || key == "twounicode" || key == "threeunicode" || key == "fourunicode" || key == "fiveunicode") {
        fivecodes.push(fivepoint[key]);
      }
    });
    participents = participents.map((part) => {
      const obj = part;
      obj.questions = [];
      selectedData.section.forEach((sec) => {
        sec.focusarea.forEach((focus) => {
          focus.reviewquestion.forEach((q) => {
            q.questionevaluation.forEach((qe) => {
              if (part.displayvalue == qe.participanttypeid) {
                obj.questions.push({
                  ...q,
                  focusareaname: focus.focusareaname,
                  sectionname: sec.sectionname,
                });
              }
            });
          });
        });
      });
      return obj;
    });
    this.setState({
      threecodes,
      fourcodes,
      fivecodes,
      participents,
      participanttypeid: participents[0] && participents[0].displayvalue,
      selectedParticipant: participents[0],
    });
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.preventDefault();
    if (!this.isBackButtonClicked) {
      if (window.confirm("Are you sure you want to close the window/tab?")) {
        this.isBackButtonClicked = true;
        this.props.history.push("./config/perform/360/form");
      } else {
        window.history.pushState(null, null, window.location.pathname);
        this.isBackButtonClicked = false;
      }
    }
  }

  onSubmit() {
    const { selectedData } = this.props;
    selectedData.isdraft = false;
    if (selectedData.formfor && !selectedData.formfor.fortypeid && !selectedData.formfor.forids) {
      selectedData.formfor = null;
    }
    if (selectedData.formfor && selectedData.formfor.forids) {
      selectedData.formfor.forids = Array.isArray(selectedData.formfor.forids) ? selectedData.formfor.forids.join(",") : selectedData.formfor.forids;
    }
    if (selectedData.section[0]) {
      selectedData.section[0].focusarea = selectedData.section[0].focusarea.length < 1 ? null : selectedData.section[0].focusarea;
      if (selectedData.section[0].focusarea && selectedData.section[0].focusarea.length > 0) {
        selectedData.section[0].focusarea = selectedData.section[0].focusarea.map((area) => ({
          ...area,
          reviewquestion: area.reviewquestion && area.reviewquestion.length > 0 ? area.reviewquestion.map((q) => ({
            ...q,
            questioninputoption: !q.questioninputoption || q.questioninputoption.length < 1 ? null : q.questioninputoption,
          })) : null,
        }));
      }
    }
    if (selectedData.section[1] && selectedData.section[1].focusarea && selectedData.section[1].focusarea.length != 0) {
      selectedData.section[1].focusarea = selectedData.section[1].focusarea.length < 1 ? null : selectedData.section[1].focusarea;
      if (selectedData.section[1].focusarea && selectedData.section[1].focusarea.length > 0) {
        selectedData.section[1].focusarea = selectedData.section[1].focusarea.map((area) => ({
          ...area,
          reviewquestion: area.reviewquestion && area.reviewquestion.length > 0 ? area.reviewquestion.map((q) => ({
            ...q,
            questioninputoption: !q.questioninputoption || q.questioninputoption.length < 1 ? null : q.questioninputoption,
          })) : null,
        }));
      }
    } else {
      selectedData.section.splice(1, 1);
    }
    selectedData.section = selectedData.section.filter((sec) => sec.weightagetypeid);
    instance.post("perform/configreviewform", selectedData)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.onCancel();
      })
      .catch((error) => {
        selectedData.section.push({
          reviewsectionid: null,
          sectionname: "Section B",
          weightagetypeid: null,
          focusarea: [],
        });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    const { participents, participanttypeid, selectedParticipant, threecodes, fourcodes, fivecodes } = this.state;
    const getCount = (id) => {
      if (id == 1) return 3;
      if (id == 2) return 4;
      if (id == 3) return 5;
      if (id == 4) return 7;
      if (id == 5) return 10;
    };

    const getCountForEmoji = (id) => {
      if (id == 1) return threecodes;
      if (id == 2) return fourcodes;
      if (id == 3) return fivecodes;
    };
    return (
      <div className="stepper-data hide-div-scroll" style={{ width: "60%" }}>
        <Grid container>
          <Grid item md={12} sm={12}>
            <div className="width40">
              <DynamicForm
                fields={selectinputconverter({
                  value: participanttypeid,
                  placeholder: "Select participant",
                  label: "View as",
                  options: participents,
                })}
                onChange={(value) => {
                  this.setState({
                    participanttypeid: value,
                    selectedParticipant: participents.find((p) => p.displayvalue == value),
                  });
                }}
              />
            </div>
          </Grid>
          {selectedParticipant
            && selectedParticipant.questions
            && selectedParticipant.questions.map((question, index) => (
              <Grid item md={12} sm={12} className="margin-top-16 question-section">
                <p className="extra-small-dark-disabled t-bold margin-bottom-4">
                  {question.sectionname}{" / "}{question.focusareaname} {" ("}{question.competencyname}{")"}
                </p>
                <Paper className="rounded-rectangle-paper padding16">
                  <p className="small-dark margin-bottom-4">
                    {index + 1}{". "}{question.question}
                  </p>
                  <p className="small-dark input-label margin-bottom-16">
                    {question.description}
                  </p>
                  <div>
                    {question.iscontributeinrating
                      && question.ratingtypeid == 1
                      && getCount(question.ratingscaletypeid)
                      && Array.from(Array(getCount(question.ratingscaletypeid)), (val, index1) => index1 + 1).map((num) => (
                        <div className="floatleft">
                          <div className="rating-scale-points-disabled">
                            <span>{num}</span>
                          </div>
                          <div className="clear-float"></div>
                        </div>
                      ))}
                    {question.iscontributeinrating
                      && question.ratingtypeid == 2
                      && getCount(question.ratingscaletypeid)
                      && Array.from(Array(getCount(question.ratingscaletypeid)), (val, index1) => index1 + 1).map(() => (
                        <div className="floatleft">
                          <div className="rating-scale-points-disabled">
                            <img style={{ width: 12 }} src={starIcon}></img>
                          </div>
                          <div className="clear-float"></div>
                        </div>
                      ))}
                    {question.iscontributeinrating
                      && question.ratingtypeid == 3
                      && getCountForEmoji(question.ratingscaletypeid)
                      && getCountForEmoji(question.ratingscaletypeid).map((emoji) => (
                        <div className="floatleft">
                          <div className="rating-scale-points">
                            {String.fromCodePoint(parseInt(emoji, 16))}
                          </div>
                          <div className="clear-float"></div>
                        </div>
                      ))}
                    {!question.iscontributeinrating
                      && question.questioninputtypeid == 2
                      && question.questioninputoption
                      && question.questioninputoption.map((op) => (
                        <div>
                          <p className="small-dark-secondary margin-bottom-8">
                            {op.optionname}
                          </p>
                        </div>
                      ))}
                  </div>
                  <div className="clear-float"></div>
                </Paper>
              </Grid>))}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

// export default Finish;
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(preview));
